import { render, staticRenderFns } from "./myCustomers.vue?vue&type=template&id=f2369886&scoped=true"
import script from "./myCustomers.vue?vue&type=script&lang=js"
export * from "./myCustomers.vue?vue&type=script&lang=js"
import style0 from "./myCustomers.vue?vue&type=style&index=0&id=f2369886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2369886",
  null
  
)

export default component.exports